'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

module.exports = function (h, that) {

  var search = that.source === 'client' ? that.search.bind(that, that.data, 'multi') : that.serverSearch.bind(that);

  var col = void 0;
  var all_values = void 0;

  var searchIt = function searchIt(val) {
    var search_values = val.length > 0 ? val : all_values;
    that.query[col] = search_values;
    search();
  };

  return function (column) {
    var data_options = [].concat(_toConsumableArray(new Set(that.data.map(function (val) {
      return val[column];
    }))));

    all_values = data_options.sort();
    col = column;
    return h('div', [h('v-multi-select', {
      attrs: {
        multiple: true,
        name: 'vf__' + column,
        options: all_values
      },
      on: {
        'input': searchIt
      }
    })]);
  };
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/template/multi-filter.js